import { TranslationMap } from '@trimble-gcs/i18n-types';

export function classificationSchemeTranslations() {
  return {
    defaultName: {
      text: $localize`:@@classificationScheme.defaultName:not defined`,
      desc:
        'Default name for a new, user-defined LIDAR classification value ' +
        'that is not defined in the project template.',
    },
    '0': {
      text: $localize`:@@classificationScheme.0:never classified`,
      desc: "Meaning of LIDAR classification value '0'.",
    },
    '1': {
      text: $localize`:@@classificationScheme.1:unclassified`,
      desc: "Meaning of LIDAR classification value '1'.",
    },
    '2': {
      text: $localize`:@@classificationScheme.2:ground`,
      desc: "Meaning of LIDAR classification value '2'.",
    },
    '3': {
      text: $localize`:@@classificationScheme.3:low vegetation`,
      desc: "Meaning of LIDAR classification value '3'.",
    },
    '4': {
      text: $localize`:@@classificationScheme.4:medium vegetation`,
      desc: "Meaning of LIDAR classification value '4'.",
    },
    '5': {
      text: $localize`:@@classificationScheme.5:high vegetation`,
      desc: "Meaning of LIDAR classification value '5'.",
    },
    '6': {
      text: $localize`:@@classificationScheme.6:building`,
      desc: "Meaning of LIDAR classification value '6'.",
    },
    '7': {
      text: $localize`:@@classificationScheme.7:noise`,
      desc: "Meaning of LIDAR classification value '7'.",
    },
    '8': {
      text: $localize`:@@classificationScheme.8:key-point`,
      desc: "Meaning of LIDAR classification value '8'.",
    },
    '9': {
      text: $localize`:@@classificationScheme.9:water`,
      desc: "Meaning of LIDAR classification value '9'.",
    },
    '10': {
      text: $localize`:@@classificationScheme.10:rail`,
      desc: "Meaning of LIDAR classification value '10'.",
    },
    '11': {
      text: $localize`:@@classificationScheme.11:road surface`,
      desc: "Meaning of LIDAR classification value '11'.",
    },
    '12': {
      text: $localize`:@@classificationScheme.12:overlap`,
      desc: "Meaning of LIDAR classification value '12'.",
    },
    '13': {
      text: $localize`:@@classificationScheme.13:wire - guard (shield)`,
      desc: "Meaning of LIDAR classification value '13'.",
    },
    '14': {
      text: $localize`:@@classificationScheme.14:wire - conductor (phase)`,
      desc: "Meaning of LIDAR classification value '14'.",
    },
    '15': {
      text: $localize`:@@classificationScheme.15:transmission tower`,
      desc: "Meaning of LIDAR classification value '15'.",
    },
    '16': {
      text: $localize`:@@classificationScheme.16:wire - structure connector (e.g. insulator)`,
      desc: "Meaning of LIDAR classification value '16'.",
    },
    '17': {
      text: $localize`:@@classificationScheme.17:bridge deck`,
      desc: "Meaning of LIDAR classification value '17'.",
    },
    '18': {
      text: $localize`:@@classificationScheme.18:high noise`,
      desc: "Meaning of LIDAR classification value '18'.",
    },
    '65': {
      text: $localize`:@@classificationScheme.65:poles`,
      desc: "Meaning of LIDAR classification value '65'.",
    },
    '66': {
      text: $localize`:@@classificationScheme.66:signs`,
      desc: "Meaning of LIDAR classification value '66'.",
    },
    '71': {
      text: $localize`:@@classificationScheme.71:stockpiles`,
      desc: "Meaning of LIDAR classification value '71'.",
    },
    '73': {
      text: $localize`:@@classificationScheme.73:steps`,
      desc: "Meaning of LIDAR classification value '73'.",
    },
    '79': {
      text: $localize`:@@classificationScheme.79:dividers`,
      desc: "Meaning of LIDAR classification value '79'.",
    },
    '200': {
      text: $localize`:@@classificationScheme.200:other and outside`,
      desc: "Meaning of LIDAR classification value '200'.",
    },
    '201': {
      text: $localize`:@@classificationScheme.201:floor`,
      desc: "Meaning of LIDAR classification value '201'.",
    },
    '202': {
      text: $localize`:@@classificationScheme.202:wall`,
      desc: "Meaning of LIDAR classification value '202'.",
    },
    '203': {
      text: $localize`:@@classificationScheme.203:ceiling`,
      desc: "Meaning of LIDAR classification value '203'.",
    },
    '204': {
      text: $localize`:@@classificationScheme.204:columns`,
      desc: "Meaning of LIDAR classification value '204'.",
    },
    '205': {
      text: $localize`:@@classificationScheme.205:beams`,
      desc: "Meaning of LIDAR classification value '205'.",
    },
    '206': {
      text: $localize`:@@classificationScheme.206:doors`,
      desc: "Meaning of LIDAR classification value '206'.",
    },
    '207': {
      text: $localize`:@@classificationScheme.207:noise`,
      desc: "Meaning of LIDAR classification value '207'. Indoor noise, distinct from class 7.",
    },
    '208': {
      text: $localize`:@@classificationScheme.208:pipes`,
      desc: "Meaning of LIDAR classification value '208'.",
    },
    '209': {
      text: $localize`:@@classificationScheme.209:wires`,
      desc: "Meaning of LIDAR classification value '209'.",
    },
    '210': {
      text: $localize`:@@classificationScheme.210:people`,
      desc: "Meaning of LIDAR classification value '210'.",
    },
    '211': {
      text: $localize`:@@classificationScheme.211:temporary structures/movable objects`,
      desc: "Meaning of LIDAR classification value '211'.",
    },
    '240': {
      text: $localize`:@@classificationScheme.240:sleepers`,
      desc: "Meaning of LIDAR classification value '240'.",
    },
    '241': {
      text: $localize`:@@classificationScheme.241:ballast`,
      desc: "Meaning of LIDAR classification value '241'.",
    },
    '242': {
      text: $localize`:@@classificationScheme.242:collisions`,
      desc: "Meaning of LIDAR classification value '242'.",
    },
  } satisfies TranslationMap;
}
